import React from 'react';
import './CertificatesSection.css';
import certImage from '../assets/certificate.png';

const CertificatesSection = () => {
  return (
    <section className="mc-section" id="certificates">
      <div className="mc-certificates">
        <div className="mc-cert-header">
          <h2 className="mc-cert-title mc-gradient-accent">Verified <span className="mc-gradient-text">Certification</span></h2>
          <p className="mc-cert-subtitle">
            Earn an industry-recognized certificate that proves your capability to build, deploy, and leverage generative AI systems.
          </p>
        </div>

        <div className="mc-cert-grid">
          <div className="mc-glass-card mc-cert-card">
            <div className="mc-cert-image-wrapper">
              <img src={certImage} alt="AI Masterclass Certificate" className="mc-cert-img" />
            </div>
            <div className="mc-cert-info">
              <div>
                <h3 className="mc-cert-name">AI Tools Bootcamp Course Completion</h3>
                <p className="mc-cert-meta">Official Credential</p>
              </div>
              <div className="mc-cert-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Verified
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificatesSection;
